// The criteria for determining whether a topic is long or short. In Japanese, a topic is short if it’s < 7 characters,
// And is long if it’s ≥ 7 characters.
export default {
	lengthCriteria: 7,
};
